export const join = {
  'join.title': 'Welcome! Create your account',
  'join.subtitle': 'Already have an account?',
  'join.phone-number-helper-text': 'In case there’s an issue with your order',
  'join.zip-code-helper-text': 'To see your local menu, offers and rewards',
  'join.create-account': 'Create account',
  'join.birthday-helper-text': '(optional) So we can celebrate your big day',
  'join.birthday-helper-text-required': 'So we can celebrate your big day',

  // ─── Join Errors ─────────────────────────────────────────────────────

  'join.error': 'Something went wrong, try again in a few moments...',
};
